import { useCallback } from 'react';

import { useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { makeSelectProperty } from '../containers/NativeAnalytics/selectors';
import { isEmpty } from '../utils';
import { formatDate } from '../utils/format-date';

const useAnalytics = () => {
  const {
    selectedBusiness,
    selectedBranch,
    selectedBrand,
    selectedDateRange,
    selectedProvider,
    selectedOwnChannel,
    selectedTab,
    selectedTimePeriod,
    selectedTimeRange,
  } = useSelector(stateSelector);

  const getAnalyticsParams = useCallback(
    overrides => {
      const resolvedOverrides = overrides || {};
      const resolvedBranch =
        resolvedOverrides.selectedBranch !== undefined
          ? resolvedOverrides.selectedBranch
          : selectedBranch;
      const resolvedBrand =
        resolvedOverrides.selectedBrand !== undefined
          ? resolvedOverrides.selectedBrand
          : selectedBrand;

      if (
        isEmpty(selectedBusiness) ||
        (isEmpty(resolvedBranch) && isEmpty(resolvedBrand))
      ) {
        return null;
      }

      const startDate = formatDate(selectedDateRange.start, 'yyyy-MM-dd');
      const endDate = formatDate(selectedDateRange.end, 'yyyy-MM-dd');

      const selectedBrandIds = !isEmpty(resolvedBrand)
        ? resolvedBrand.map(b => b.id).join(',')
        : '';

      const selectedBranchIds = !isEmpty(resolvedBranch)
        ? resolvedBranch.map(b => b.id).join(',')
        : '';

      const providerIds = !isEmpty(selectedProvider)
        ? selectedProvider.map(p => p.id).join(',')
        : [];

      const channelIds = !isEmpty(selectedOwnChannel)
        ? selectedOwnChannel.map(c => c.id).join(',')
        : [];

      const params = {
        provider_id: providerIds,
        branch_id: selectedBranchIds,
        brand_id: selectedBrandIds,
        period_start: startDate,
        period_hour_start: selectedTimeRange?.startTime?.id,
        period_hour_end: selectedTimeRange?.endTime?.id,
        period: selectedTimePeriod?.id,
        order_source: channelIds,
      };

      params.period_end = endDate;

      return { ...params };
    },
    [
      selectedBusiness,
      selectedBranch,
      selectedBrand,
      selectedDateRange,
      selectedProvider,
      selectedOwnChannel,
      selectedTab,
      selectedTimePeriod,
      selectedTimeRange,
    ],
  );

  return {
    getAnalyticsParams,
  };
};

const stateSelector = createStructuredSelector({
  selectedBusiness: makeSelectProperty('selectedBusiness'),
  selectedBranch: makeSelectProperty('selectedBranch'),
  selectedBrand: makeSelectProperty('selectedBrand'),
  selectedDateRange: makeSelectProperty('selectedDateRange'),
  selectedProvider: makeSelectProperty('selectedProvider'),
  selectedOwnChannel: makeSelectProperty('selectedOwnChannel'),
  selectedTab: makeSelectProperty('selectedTab'),
  selectedTimePeriod: makeSelectProperty('selectedTimePeriod'),
  selectedTimeRange: makeSelectProperty('selectedTimeRange'),
});

export default useAnalytics;
